export const API_BASE_URL =
  import.meta.env.VITE_APP_ENV === 'staging'
    ? 'https://trpc.webcatalog.dev'
    : import.meta.env.VITE_APP_ENV === 'local'
      ? 'http://localhost:5203'
      : 'https://trpc.webcatalog.io';
